module.exports = require('./helpers/bundle-url').getBundleURL('ak0ox') + "arcgis-logo.72697dab.png";